import {
  ChangeDetectorRef, Component, Input, Output, EventEmitter,
  OnInit, ViewChild, NgZone,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';

import { ManageBillingFormComponent } from './manage-billing-form/manage-billing-form.component';
import { InfoModalComponent } from '../../modal/info-modal/info-modal.component';
import { BaseModalComponent } from '../../modal/_base-modal.component';
import { defaultBillingData } from './default-billing-data';
import { SubscriptionService } from '../../subscription/subscription.service';
import { LoaderComponent } from '../../loader/loader.component';


@Component({
  moduleId: module.id,
  selector: 'manage-billing-modal',
  templateUrl: 'manage-billing-modal.component.html',
  styleUrls: ['manage-billing-modal.component.scss'],
})
export class ManageBillingModalComponent extends BaseModalComponent implements OnInit {

  processing: boolean = false;

  form: UntypedFormGroup;

  billingData: any = defaultBillingData;

  error: string;

  @Input() data: any;
  @Input() isAdd: boolean = false; // true - add billing info, false - change billing info

  @Output() submitCard = new EventEmitter();

  @ViewChild('infoModal', {static: false}) infoModal: InfoModalComponent | void;

  @ViewChild(ManageBillingFormComponent, {static: false}) manageBillingForm: ManageBillingFormComponent | void;

  @ViewChild('manageBillingModalLoader', {static: false}) loader: LoaderComponent | void;

  constructor(
    private ref: ChangeDetectorRef,
    private subscriptionService: SubscriptionService,
    private _zone: NgZone
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isActionsAvailable() {
    return this.form ? this.form.valid : false;
  }

  get canSave() {
    return !this.processing && this.form.valid;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    if (!this.data) {
      this.data = this.billingData;
    }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public show() {
    this.clearData();
    super.show();
  }

  public hide() {
    if (this.manageBillingForm instanceof ManageBillingFormComponent) {
      this.manageBillingForm.clearForm();
      this.form = this.manageBillingForm.form;
    }
    super.hide();
  }

  public showLoader() {
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
    this.processing = true;
    this.ref.markForCheck();
  }

  public hideLoader() {
    if (this.loader instanceof LoaderComponent) {
      this.loader.hide();
    }
    this.processing = false;
    this.ref.markForCheck();
  }

  public setError(error: string) {
    this.error = error;
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onUpdateClick() {
    if (!this.isActionsAvailable) { return; }

    const value = this.form.controls['expDate'].value;
    const controlDate = value.slice(0, 2) + '/' + value.slice(2, 4);
    const expDate = controlDate.split('/');

    this.submitCard.emit({
      email:  this.form.controls['email'].value,
      number: this.form.controls['creditCard'].value,
      exp_month: expDate[0],
      exp_year: expDate[1],
      cvc: this.form.controls['cvv'].value,
      address_line1: this.form.controls['address1'].value,
      address_line2: this.form.controls['address2'].value,
      address_city: this.form.controls['city'].value,
      address_state: this.form.controls['state'].value,
      address_zip: this.form.controls['zipCode'].value,
      address_country: this.form.controls['country'].value,
      name: this.form.controls['cardholderName'].value.toUpperCase(),
    });
  }

  onFormChange(form: UntypedFormGroup) {
    this.form = form;
    this.ref.markForCheck();
  }

  onFormDataChanged() {
    this.error = undefined;
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private clearData() {
    this.processing = false;
    this.error = undefined;
    this.ref.markForCheck();
  }
}
